

























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import { Device } from '@capacitor/device';

@Component({
})
export default class PrivacyPolicyScreen extends Vue { 
    public languageKey: any = 'en';
    public dismissScreen() {
        this.$store.commit(Mutations.DISMISS_TERMS);
    }

    
    public beforeCreate() {
        Device.getLanguageCode()
        .then((language) => {
            this.languageKey = typeof language.value !== 'undefined' ? language.value.split('-')[0] : 'en';
        });
    }
    
}

